import PictureHome from 'Pages/picture/home/home'
import React from 'react'
import fetch from 'isomorphic-unfetch'
import getUrl from 'lib/url'
import { get } from 'lodash'
import {
  IConditionsProps,
  IInfoProps,
  ISortProps,
} from 'Pages/picture/home/interface'

// 重新处理数据

// posts will be populated at build time by getStaticProps()
function Picture({ conditions, brands, sort, letters }: any) {
  return (
    <PictureHome
      conditions={conditions}
      sort={sort}
      letters={letters}
      brands={brands}
    />
  )
}
function reHandleData(data: any) {
  // 更多条件
  const conditions = get(data, '[2].info.filters[3].data.options', [])
  conditions.forEach((item: IConditionsProps) => {
    item.data.unshift({
      text: '不限',
      key: '',
      param: '',
    })
  })

  // 价格
  const price = get(data, '[2].info.filters[1].data.options', [])
  const newPrice = price.map((item: ISortProps) => {
    return {
      param: item.text === '价格不限' ? null : item.param,
      text: item.text === '价格不限' ? '不限' : item.text,
      key: 'price',
    }
  })
  // 价格允许自定义
  newPrice.push({
    key: 'price',
    text: '输入框',
  })
  conditions.unshift({ title: '价格', data: newPrice })

  // 按价格排序等过滤条件
  const sort = get(data, '[2].info.filters[0].data.options', []).map(
    (item: ISortProps) => {
      return {
        key: 'sort',
        text: item.text,
        param: item.param,
      }
    }
  )

  // 处理品牌
  let list: IInfoProps[] = []
  const brands: IInfoProps[][] = []
  const letters: string[] = []
  data &&
    data.slice(3).forEach((item: IInfoProps) => {
      if (item.type === '1000') {
        letters.push(item.info.pinyin)
        brands.push(list)
        list = []
      }
      if (item.type === '1000' || item.type === '1001') {
        list.push(item)
      }
    })
  brands.push(list)
  brands.shift()
  return {
    conditions: conditions.filter(
      (item: IConditionsProps) => item.title === '级别'
    ),
    sort,
    letters,
    brands,
  }
}
Picture.getInitialProps = async () => {
  const res = await fetch(
    getUrl('/motor/brand/m/v1/brand/?device_id=0&data_from=pc_station')
  )
  const json =
    (await res.json().catch(err => {
      console.log(err)
    })) || {}
  const data = reHandleData(json.data) || {}

  return data
}

export default Picture
